import AitiProductImpression from './impression.mjs';

/**
 * @class
 */
var AitiProductImpressionsCollector = function() {

    let _this = this;

    this._impressions = {};

    this._collect = function(element) {
        let $element = $j(element);

        let impression = new AitiProductImpression(
            element,
            $element.attr('data-product-impression'),
            $element.attr('data-product-impression-source'),
            AitiCore.getStore().getId()
        );

        if (_this._getImpressions().hasOwnProperty(impression.getKey()) && _this._getImpressions()[impression.getKey()].getElement() === element) {
            return;
        }

        _this._getImpressions()[impression.getKey()] = impression;
        DeferredEvents.trigger(AitiProductImpressionsCollector.EVENT_COLLECT, {impression: impression});
    };

    /**
     * @returns {Object.<string, AitiProductImpression>}
     */
    this._getImpressions = function() {
        return this._impressions;
    };

    this._isRectInViewport = function(rect) {
        if (rect.top === 0 && rect.bottom === 0 && rect.width === 0 && rect.height === 0) {
            return false;
        }

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=CartEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onCollect = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductImpressionsCollector.EVENT_COLLECT, handler, priority, ignoreCancel, this);
        return this;
    };

    $j(function() {
        if (typeof IntersectionObserver === 'undefined' || typeof MutationObserver === 'undefined') {
            return;
        }

        let intersectionObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (_this._isRectInViewport(entry.boundingClientRect)) {
                    _this._collect(entry.target);
                }
            });
        }, {
            threshold: [0.2, 0.4, 0.6, 0.8, 1.0]
        });

        $j(AitiProductImpressionsCollector.SELECTOR_PRODUCT_IMPRESSION).each(function() {
            intersectionObserver.observe(this);
        });

        let mutationObserver = new MutationObserver(function(entries) {
            entries.forEach(function(entry) {
                entry.addedNodes.forEach(function(node) {
                    $j(AitiProductImpressionsCollector.SELECTOR_PRODUCT_IMPRESSION, node).each(function() {
                        intersectionObserver.observe(this);
                    });
                });
            });
        });

        mutationObserver.observe($j('body')[0], {subtree: true, childList: true});
    });
}

/** EVENTS */
AitiProductImpressionsCollector.EVENT_COLLECT = 'product_impression_collect';

/** SELECTORS */
AitiProductImpressionsCollector.SELECTOR_PRODUCT_IMPRESSION = '[data-product-impression]';

export default AitiProductImpressionsCollector;
